import Service from 'src/services/thresholds.service'
import { executeAction } from 'src/actions/global.actions'

export const actions = {
  GET_THRESHOLDS: 'GET_THRESHOLDS',
  UPDATE_THRESHOLDS: 'UPDATE_THRESHOLDS',
}

export const getThresholds = (thresholdType: number, posId?: number) => dispatch => {
  const process = async () => ({
    payload: await Service.getThresholds(thresholdType, posId),
  })
  dispatch(executeAction(actions.GET_THRESHOLDS, process))
}

export const updateThresholds =
  (thresholdType: number, request: IThresholdRequest[], posId?: number) => dispatch => {
    const process = async () => ({
      payload: await Service.updateThresholds(thresholdType, request, posId),
    })
    dispatch(executeAction(actions.UPDATE_THRESHOLDS, process))
  }
